import { render, staticRenderFns } from "./outList.vue?vue&type=template&id=37c4885a&"
import script from "./outList.vue?vue&type=script&lang=js&"
export * from "./outList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports